import request from '@/utils/request';

export function updatePager(data) {
  return request({
    url: '/exam/paper/update',
    method: 'post',
    data,
    successMessage: 'success',
  });
}

export function savePager(data) {
  return request({
    url: '/exam/paper/save',
    method: 'put',
    data,
    successMessage: 'success',
  });
}

export function getPagerInfo(id) {
  return request({
    url: `/exam/paper/info/${id}`,
    method: 'get',
  });
}

export function getPager(id) {
  return request({
    url: `/exam/paper/${id}`,
    method: 'get',
  });
}

export function answersheetAnswer(data) {
  return request({
    url: `/exam/answersheet/answer`,
    method: 'put',
    data,
    errorMessage: 'none',
  });
}

// 补考重置
export function answersheetRetest(id) {
  return request({
    url: `/exam/answersheet/retest/${id}`,
    method: 'get',
    successMessage: 'success',
  });
}

// 提交试卷
export function upAnswersheetAnswer(data) {
  return request({
    url: `/exam/answersheet/answer`,
    method: 'put',
    data
  });
}

// 试卷列表 管理页面
export function getPagerList(data) {
  return request({
    url: `/exam/paper/myExams`,
    method: 'post',
    data,
  });
}

// 试卷试题修改
export function uploadQuestion(data) {
  return request({
    url: `/exam/question/update`,
    method: 'post',
    data,
    successMessage: 'success',
  });
}
